
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    text: { type: String, required: true },
    bgColor: { type: String, default: '#579D3D' },
    fontColor: { type: String, default: 'white' }
  },
  setup(props) {
    return {
      tagStyle: {
        backgroundColor: props.bgColor,
        color: props.fontColor
      }
    }
  }
})
